import { setCategoriesRaw } from '../../action/raw';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [forAction(setCategoriesRaw, identityPayload)],
  initialState,
);
